import { render, staticRenderFns } from "./comNavigationBar.vue?vue&type=template&id=9674f940&scoped=true"
import script from "./comNavigationBar.vue?vue&type=script&lang=js"
export * from "./comNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./comNavigationBar.vue?vue&type=style&index=0&id=9674f940&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9674f940",
  null
  
)

export default component.exports